import {
  IUserLibraryFeaturedV2ResponseOK,
  useQueryUserLibraryFeaturedV2,
  useQueryUserLibraryFeaturedV3,
} from '@ifit/gateway-wolf-athenaeum-service';
import { useParams } from 'react-router-dom';
import { CategoryParams } from '../../../views/routes';
import { useInfiniteQueryOptions, challengeStoreFF } from '../query-options';
import { useFeatureFlags } from '../../../helpers/good-cop-helper';
import { QueryObserverResult } from 'react-query';
import { AxiosError } from 'axios';

export const useFeaturedContentRowQuery = (): QueryObserverResult<
  IUserLibraryFeaturedV2ResponseOK,
  AxiosError<unknown>
> => {
  const featureFlags = useFeatureFlags([challengeStoreFF]);
  const enabled = featureFlags[challengeStoreFF]
    ? (featureFlags[challengeStoreFF] as boolean)
    : false;
  const opts = useInfiniteQueryOptions();
  const v3Results = useQueryUserLibraryFeaturedV3(opts, { enabled });
  const v2Results = useQueryUserLibraryFeaturedV2(opts, { enabled: !enabled });
  return enabled ? v3Results : v2Results;
};

export const useFeaturedContentCategoryQuery = (): QueryObserverResult<
  IUserLibraryFeaturedV2ResponseOK,
  AxiosError<unknown>
> => {
  const featureFlags = useFeatureFlags([challengeStoreFF]);
  const enabled = featureFlags[challengeStoreFF]
    ? (featureFlags[challengeStoreFF] as boolean)
    : false;
  const { categorySlug: categoryName } = useParams<CategoryParams>();
  const opts = { ...useInfiniteQueryOptions() };
  const v3Results = useQueryUserLibraryFeaturedV3(
    { ...opts, category: categoryName },
    { enabled },
  );
  const v2Results = useQueryUserLibraryFeaturedV2(
    { ...opts, category: categoryName },
    { enabled: !enabled },
  );
  return enabled ? v3Results : v2Results;
};
